// extracted by mini-css-extract-plugin
module.exports = {"fantasyCard":"fantasy_fantasyCard__qRynJ","fantasyCardContent":"fantasy_fantasyCardContent__wn2oN","line":"fantasy_line__5qS36"};